import SlimSelect from "slim-select";
import {getCookie} from "../../sources/js/functions/helpers";

(function () {
    const form = document.querySelector('[data-contact-form] form');
    const notice = document.querySelector('[data-contact-form-notice]');
    const closeNotice = document.querySelector('[data-contact-form-notice] a');

    if (closeNotice) {
        closeNotice.addEventListener('click', () => notice.style.display = 'none')
    }

    if (form) {
        const radios = form.querySelectorAll('input[name="contact-type"]');
        const file = form.querySelector('.wpcf7-form__line_file input');
        const fileBtn = form.querySelector( ".wpcf7-form__line_file label");
        const currLang = getCookie('current_language');

        const toggleInputs = (currValue) => {
            if (currValue) {
                switch (currValue) {
                    case 'Email':
                    case 'විද්යුත්තැපෑල':
                        form.querySelector('.wpcf7-form__line_email').style.display = 'block'
                        form.querySelector('.wpcf7-form__line_phone').style.display = 'none'
                        break;
                    case 'Phone':
                    case 'දුරකථන':
                        form.querySelector('.wpcf7-form__line_email').style.display = 'none'
                        form.querySelector('.wpcf7-form__line_phone').style.display = 'block'
                        break;
                }
            }
        }

        // Init combobox
        const selectHtml = document.querySelector('#userSubject').innerHTML
        document.querySelector('#userSubject').innerHTML = `<option data-placeholder="true" value=""></option>` + selectHtml;

        const select = new SlimSelect({
            select: '#userSubject',
            settings: {
                showSearch: false,
                placeholderText: currLang === 'en' ? 'Subject' : 'කරුණාකර විශයක් තෝරන්න',
            },
        })

        // File events
        fileBtn.addEventListener('keydown', (e) => {
            if (e.keyCode == 13 || e.keyCode == 32) file.focus();
        });

        fileBtn.addEventListener('click', () => {
            file.focus();
            return false;
        });

        file.addEventListener('change', (e) => {
            fileBtn.innerHTML = e.target.files[0].name
        });

        // Type change
        radios.forEach(input => {
            if (input.checked) toggleInputs(input.value)

            input.addEventListener('click', e => toggleInputs(e.target.value))
        });

        document.addEventListener('wpcf7mailsent', function (event) {
            // Show Notice
            notice.style.display = 'block'

            /*
            document.body.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
             */

            // Clear Form
            form.reset();
            select.setSelected('')
            toggleInputs('Phone');

            // Hide Notice
            setTimeout(() => notice.style.display = 'none', 10000);
        });
    }
}());
